import { faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {
  IconStyled,
  SocialNetworkContainer,
} from './SocialNetworksBFACM.styles';

const Icon = ({ iconName, link, hasMarginRight }) => (
  <IconStyled
    href={link}
    target="_blank"
    rel="noopener"
    hasMarginRight={hasMarginRight}
  >
    <FontAwesomeIcon icon={iconName} />
  </IconStyled>
);

Icon.propTypes = {
  iconName: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  hasMarginRight: PropTypes.bool,
};

export const SocialNetworksBFACM = () => (
  <SocialNetworkContainer>
    <Icon
      iconName={faLinkedinIn}
      link="https://www.linkedin.com/company/bfacapitalmarkets/?trk=public_post_main-feed-card_reshare_feed-actor-image&originalSubdomain=ao"
      hasMarginRight
    />
    <Icon
      iconName={faInstagram}
      link="https://instagram.com/bfacapitalmarkets?igshid=MzRlODBiNWFlZA=="
      hasMarginRight
    />
  </SocialNetworkContainer>
);
